/**
 * Results per page on /search (Asana 1219353862024235). Mirrors the backend cap
 * on GET /cards/search-light (`pageSize` max 60, 400 above); the page sends both
 * `pageSize` and the legacy `limit` so an older backend still serves 60 rows.
 */
export const SEARCH_PAGE_SIZE = 60;

/** The two result shapes the backend serves: every printing, or one tile per card. */
export type SearchView = 'printings' | 'cards';
export const SEARCH_DEFAULT_VIEW: SearchView = 'printings';

/**
 * The "Show" dropdown on the Search toolbar (Asana 1219902640605024). Order is
 * display order; the default view comes first. A third option (Unique Art) is a
 * one-line addition here, nowhere else.
 */
export const SEARCH_VIEW_OPTIONS: ReadonlyArray<{ value: SearchView; label: string }> = [
  { value: 'printings', label: 'All Prints' },
  { value: 'cards', label: 'Unique Cards' },
];

/** Prefix on the closed chip, mirroring the Sort chip ("Sort: Point Value"). */
export const SHOW_LABEL_PREFIX = 'Show: ';
